import axios from 'axios'
import router from '../../router'

/**
 * http.js插件
 * @param Vue Vue构造函数
 * @param option
 */
function install(Vue, option) {
  let axiosIns = axios.create({});
  if (process.env.NODE_ENV == 'development') {
    axiosIns.defaults.baseURL = 'http://test.leemma.com/api/private/';
  } else if (process.env.NODE_ENV == 'debug') {
    axiosIns.defaults.baseURL = '/api/private/';
  } else if (process.env.NODE_ENV == 'production') {
    axiosIns.defaults.baseURL = '/api/private/';
  }
  axiosIns.interceptors.request.use(req => {
    //填充auth_token
    let params = req.data ? req.data : req.params,
      info = JSON.parse(localStorage.getItem('account'));
    if (params&&(params.auth_token === 'default')) {
      if(!info){
        router.push({path:'/error?code=401'})
      }
      params.auth_token =info.auth_token;
      params.company_id = params.company_id? params.company_id : info.company_id;
     // 拦截空参数
      for(let key in params){
        let item = params[key];
        if(!item){
          delete params[key]
        }
      }

      if (req.params) {
        req.params = params
      } else {
        req.data = params
      }
    }

    return req;
  });
  //返回状态判断(添加响应拦截器)
  axiosIns.interceptors.response.use(
    res => {
      if (res.data) {
        return res.data
      }

    },error => {
      if(error.response){
        let errorInfo = error.response.data.error ? error.response.data.error : error.response.data;
        let status = error.response.status
        if(status === 401){
          router.push({path:'/error?code=401'})
        }else if(status===404){
          // router.push({path:'/error?code=404'})

        }
      }
      return Promise.reject(error);

    });

  //全局实例方法
  Vue.prototype.$http = axiosIns
}

export default install;



// WEBPACK FOOTER //
// ./src/assets/lib/http.js